import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { Instance } from 'src/app/models/centrex/instance';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class InstanceService extends ServiceBase implements OnDestroy {
    currentOrganizationChange: Subscription;

    public currentInstance: BehaviorSubject<Instance>;

    public get currentInstanceChange$() {
        return this.currentInstance.asObservable();
    }

    public instance = signal<Instance | null>(null);

    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();

        this.currentInstance = new BehaviorSubject<Instance>(JSON.parse(sessionStorage.getItem('currentInstance')));
        this.instance.set(JSON.parse(sessionStorage.getItem('currentInstance')));

        this.currentOrganizationChange = this.organizationsServices.currentOrganizationChange$
            .pipe(
                switchMap((o) => {
                    if (o) {
                        return this.loadInstance();
                    } else {
                        return of(null);
                    }
                })
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.currentOrganizationChange.unsubscribe();
    }

    getCurrentInstance(): Instance {
        return this.currentInstance.value;
    }

    setCurrentInstance(instance: Instance) {
        if (instance == null) {
            sessionStorage.removeItem('currentInstance');
            this.instance.set(null);
        } else {
            sessionStorage.setItem('currentInstance', JSON.stringify(instance));
            this.instance.set({ ...instance });
        }

        console.log('Current Instance : ' + (instance?.id ?? '<null>'));

        this.currentInstance.next(instance);
    }

    initializeInstance(instance): Observable<Instance> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Instance>(`${this.baseUrl}/api/instance`, instance, httpOptions);
    }

    getInstance(): Observable<Instance> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Instance>(`${this.baseUrl}/api/instance`, httpOptions);
    }

    getDefaultInstance(): Observable<Instance> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Instance>(`${this.baseUrl}/api/instance/default`, httpOptions);
    }

    loadInstance(): Observable<Instance> {
        return this.getInstance().pipe(
            tap((instance) => {
                if (instance?.id !== this.currentInstance.value?.id) {
                    this.setCurrentInstance(instance);
                }
            })
        );
    }

    get isInitialized(): boolean {
        return this.currentInstance.value != null;
    }

    get isSelected(): boolean {
        return this.organizationsServices.getCurrentOrganization() != null;
    }
}
